import {
  clientConfig,
  defaultClient
} from "../constants/config";

export const getRedirectUrl = (url) => {
  const clientId = sessionStorage.getItem("clientId");
  if (decodeURI(url).startsWith(process.env.REACT_APP_START)) {
    return url;
  } else if (clientId !== defaultClient && clientConfig.hasOwnProperty(clientId)) {
    const config = clientConfig[clientId];
    const envConfig = config[process.env.REACT_APP_ENV];
    if (decodeURI(url).startsWith(envConfig.start)) {
      return url;
    } else {
      const decodeUrl = decodeURI(url);
      const replacedUrl = decodeUrl.replace(/^(https?:\/\/[^\/]+\/)/, envConfig.start);
      return encodeURI(replacedUrl);
    }
  }
  return process.env.REACT_APP_START;
}
